/**
 * htmlToParagraphs — converte uma string HTML (vinda do back, ex.: a mensagem de
 * status do pedido) em parágrafos de TEXTO PURO, de forma segura.
 *
 * Segurança: usa `DOMParser` com `text/html` apenas para LER o `textContent`.
 * Esse parsing NÃO executa scripts nem carrega recursos, e o resultado nunca é
 * injetado no DOM (sem `dangerouslySetInnerHTML`) — apenas texto é renderizado.
 * Logo, não há superfície de XSS, mesmo que o HTML contenha `<script>` ou
 * handlers como `onerror`.
 *
 * - Extrai o texto de cada bloco `<p>`; sem `<p>`, usa o texto total do body.
 * - Colapsa espaços/quebras. Strings sem tags voltam como um único parágrafo.
 */
export const htmlToParagraphs = (html: string): string[] => {
  if (!html) return [];

  const looksLikeHtml = /<[a-z!/][\s\S]*>/i.test(html);
  if (!looksLikeHtml) {
    const text = html.replace(/\s+/g, ' ').trim();
    return text ? [text] : [];
  }

  const doc = new DOMParser().parseFromString(html, 'text/html');

  const paragraphs = Array.from(doc.body.querySelectorAll('p'))
    .map((p) => (p.textContent || '').replace(/\s+/g, ' ').trim())
    .filter(Boolean);

  if (paragraphs.length > 0) return paragraphs;

  const text = (doc.body.textContent || '').replace(/\s+/g, ' ').trim();
  return text ? [text] : [];
};

export default htmlToParagraphs;
